import React from 'react';

import PropTypes from '../utils/propTypes';
import Avatar from '@material-ui/core/Avatar';
import classNames from 'classnames';


import userImage from '../../assets/img/logo/nepal.png';
const AvatarComp = ({
  rounded,
  circle,
  src,
  size,
  // tag: Tag,
  className,
  style,
  ...restProps
}) => {
  const classes = classNames({  rounded }, className);
  return (
    <Avatar
      src={src}
      style={{ width: size, height: size, ...style }}
      // className={classes}
      {...restProps}
    />
  );
};

Avatar.propTypes = {
  tag: PropTypes.component,
  rounded: PropTypes.bool,
  circle: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  src: PropTypes.string,
  style: PropTypes.object,
};

AvatarComp.defaultProps = {
  tag: 'img',
  rounded: false,
  circle: true,
  size: 40,
  src: userImage,
  style: {},
};

export default AvatarComp;
